import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import HomePage from './components/Home/Home';
import CallScore from './components/CallScore/CallScoreHome';
import HumanCallSteps from './components/CallScoreOld/HumanCallSteps/HumanCallSteps';
import './App.scss';
import HumanCallScore from "./components/CallScore/HumanCallScore/HumanCallScore";
import GenerateCallScoreButton from "./components/Demo/GenerateCallScoreButton"
import  {ReactComponent as SymblLogo} from "./assets/icons/SymblLogo.svg";
import ScoreAIAgent from "./components/CallScore/ScoreAIAgent/ScoreAIAgent";
import RealTimeAssist from "./components/RealTimeAssist/RealTimeAssist";
import ViewCallScore from "./components/ViewCallScore/ViewCallScore";
import ViewInsightsUIDetails from "./components/ViewInsightsUIDetails/ViewInsightsUIDetails";
import ViewInsightsUIList from './components/ViewInsightsUIList/ViewInsightsUIList';
import { Link } from 'react-router-dom';
import {useEffect, useState, createContext} from "react";
import {getSymblAccessToken} from "./services/callScore";
import {ROUTES} from "./constants";
import {FormControlLabel, Switch} from "@mui/material";
import { DarkModeSwitch } from 'react-toggle-dark-mode';
import DemoCallScore from './components/Demo_CallScore';
import DemoVoiceAiAgent from './components/Demo_VoiceAiAgent';

export const IsDarkThemeOnContext = createContext(false);

function AppContent() {
  const [finalConversationId, setFinalConversationId] = useState('');
  const location = useLocation();
  const isViewInsightsUIDetailsRoute = location.pathname === ROUTES.VIEW_INSIGHTS_UI_DETAILS;
  const isDemoPath = location.pathname.startsWith('/demos');

  useEffect(() => {
    document.title = "Symbl.ai : Quest";
  }, []);

  useEffect(() => {
    if (!isDemoPath) {
      getSymblAccessToken(true);
    }
  }, [isDemoPath]);

  const [isDarkThemeOn, setDarkTheme] = useState(() => {
    if (isViewInsightsUIDetailsRoute) {
      return false;
    }
    return localStorage.getItem('isDarkThemeOn') === "true";
  });

  useEffect(() => {
    if (isViewInsightsUIDetailsRoute) {
      setDarkTheme(false);
    } else {
      setDarkTheme(localStorage.getItem('isDarkThemeOn') === "true");
    }
  }, [isViewInsightsUIDetailsRoute]);

  const toggleTheme = () => {
    if (!isViewInsightsUIDetailsRoute) {
      const toggled = !isDarkThemeOn;
      localStorage.setItem('isDarkThemeOn', toggled.toString());
      setDarkTheme(toggled);
    }
  }

  // Render only the demo component without header
  if (isDemoPath) {
    return (
      <div className="App">
        <Routes>
          <Route path={ROUTES.SYMBL_DEMO_CALL_SCORE} element={<DemoCallScore />} />
          <Route path={ROUTES.SYMBL_DEMO_VOICE_AI_AGENT} element={<DemoVoiceAiAgent />} />
        </Routes>
      </div>
    );
  }

  return (
    <div className="App" id={`${isDarkThemeOn && !isViewInsightsUIDetailsRoute ? 'dark-theme' : 'light-theme'}`}>
      <header className={"header"}>
        <Link to="/">
          <SymblLogo/>
        </Link>
        <div style={{ display: 'flex' }} className={'callscore-button'}>
          {finalConversationId && <GenerateCallScoreButton conversationId={finalConversationId} setFinalConversationId={setFinalConversationId} />}
          <div className={"theme-toggle"} style={{ marginLeft: '16px' }}>
            <DarkModeSwitch 
              onChange={toggleTheme} 
              checked={isDarkThemeOn} 
              disabled={isViewInsightsUIDetailsRoute}
            />
          </div>
        </div>
      </header>
      <Routes>
        <Route path={ROUTES.HOME_PAGE} element={<HomePage />} />
        <Route path={ROUTES.CALL_SCORE} element={<CallScore />} />
        <Route path={ROUTES.OLD_CALL_SCORE} element={<HumanCallSteps />} />
        <Route path={ROUTES.HUMAN_CALL_SCORE} element={<HumanCallScore />} />
        <Route path={ROUTES.SCORE_AI_AGENT} element={<HumanCallScore evaluateAiAgent={true} />} />
        <Route path={ROUTES.REAL_TIME_ASSIST} element={<RealTimeAssist setFinalConversationId={setFinalConversationId} />} />
        <Route path={ROUTES.VIEW_CALL_SCORE} element={<ViewCallScore />} />
        <Route path={ROUTES.VIEW_INSIGHTS_UI_DETAILS} element={<ViewInsightsUIDetails />} />
        <Route path={ROUTES.VIEW_INSIGHTS_UI_LIST} element={<ViewInsightsUIList />} />
      </Routes>
    </div>
  );
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const location = useLocation();

  const isDemoPath = () => {
    return location.pathname.startsWith('/demos');
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (password === 'Symbl123') {
      setIsAuthenticated(true);
    } else {
      alert('Incorrect password');
    }
  };

  // Skip authentication for demo paths
  if (!isAuthenticated && !isDemoPath()) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', backgroundColor: '#f3f4f6' }}>
        <div style={{ backgroundColor: 'white', padding: '2rem', borderRadius: '0.5rem', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', width: '300px' }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1.5rem' }}>
            <SymblLogo style={{ width: '120px', height: 'auto' }} />
          </div>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '1.5rem', textAlign: 'center', color: '#1f2937' }}>Authentication Required</h2>
          <form onSubmit={handleFormSubmit}>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              style={{ width: '90%', padding: '0.75rem', marginBottom: '1rem', border: '1px solid #d1d5db', borderRadius: '0.25rem', fontSize: '1rem' }}
            />
            <button 
              type="submit" 
              style={{ width: '100%', backgroundColor: '#3b82f6', color: 'white', padding: '0.75rem', border: 'none', borderRadius: '0.25rem', fontSize: '1rem', cursor: 'pointer' }}
            >
              Submit
            </button>
          </form>
        </div>
      </div>
    );  
  }

  return (
    <IsDarkThemeOnContext.Provider value={false}>
      <AppContent />
    </IsDarkThemeOnContext.Provider>
  );
}

export default function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}
